function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { extend } from "../../../shared/utils/extend.js";
import { Carousel } from "../../../Carousel/Carousel.js";
var defaults = {
  // The minimum number of images in the gallery to display thumbnails
  minSlideCount: 2,
  // Minimum screen height to display thumbnails
  minScreenHeight: 500,
  // Automatically show thumbnails when opened
  autoStart: true,
  // Keyboard shortcut to toggle thumbnail container
  key: "t",
  // Customize Carousel instance
  Carousel: {}
};
export var Thumbs = /*#__PURE__*/function () {
  function Thumbs(fancybox) {
    _classCallCheck(this, Thumbs);

    this.fancybox = fancybox;
    this.$container = null;
    this.state = "init";

    for (var _i = 0, _arr = ["onPrepare", "onClosing", "onKeydown"]; _i < _arr.length; _i++) {
      var methodName = _arr[_i];
      this[methodName] = this[methodName].bind(this);
    }

    this.events = {
      prepare: this.onPrepare,
      closing: this.onClosing,
      keydown: this.onKeydown
    };
  }
  /**
   * Process `prepare` event to build the layout
   */


  _createClass(Thumbs, [{
    key: "onPrepare",
    value: function onPrepare() {
      // Get slides, skip if the total number is less than the minimum
      var slides = this.getSlides();

      if (slides.length < this.fancybox.option("Thumbs.minSlideCount")) {
        this.state = "disabled";
        return;
      }

      if (this.fancybox.option("Thumbs.autoStart") === true && this.fancybox.Carousel.Panzoom.content.height >= this.fancybox.option("Thumbs.minScreenHeight")) {
        this.build();
      }
    }
    /**
     * Process `closing` event to disable all events
     */

  }, {
    key: "onClosing",
    value: function onClosing() {
      if (this.Carousel) {
        this.Carousel.Panzoom.detachEvents();
      }
    }
    /**
     * Process `keydown` event to enable thumbnail list toggling using keyboard key
     * @param {Object} fancybox
     * @param {String} key
     */

  }, {
    key: "onKeydown",
    value: function onKeydown(fancybox, key) {
      if (key === fancybox.option("Thumbs.key")) {
        this.toggle();
      }
    }
    /**
     * Build layout and init thumbnail Carousel
     */

  }, {
    key: "build",
    value: function build() {
      var _this = this;

      if (this.$container) {
        return;
      } // Create wrapping element and append to layout


      var $container = document.createElement("div");
      $container.classList.add("fancybox__thumbs");
      this.fancybox.$carousel.parentNode.insertBefore($container, this.fancybox.$carousel.nextSibling); // Initialise thumbnail carousel with all slides

      this.Carousel = new Carousel($container, extend(true, {
        Dots: false,
        Navigation: false,
        Sync: {
          friction: 0
        },
        infinite: false,
        center: true,
        fill: true,
        dragFree: true,
        slidesPerPage: 1,
        preload: 1
      }, this.fancybox.option("Thumbs.Carousel"), {
        Sync: {
          target: this.fancybox.Carousel
        },
        slides: this.getSlides()
      })); // Slide carousel on wheel event

      this.Carousel.Panzoom.on("wheel", function (panzoom, event) {
        event.preventDefault();

        _this.fancybox[event.deltaY < 0 ? "prev" : "next"]();
      });
      this.$container = $container;
      this.state = "visible";
    }
    /**
     * Process all fancybox slides to get all thumbnail images
     */

  }, {
    key: "getSlides",
    value: function getSlides() {
      var slides = [];

      var _iterator = _createForOfIteratorHelper(this.fancybox.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var slide = _step.value;
          var thumb = slide.thumb;

          if (thumb) {
            slides.push({
              html: "<div class=\"fancybox__thumb\" style=\"background-image:url('".concat(thumb, "')\"></div>"),
              customClass: "has-thumb has-".concat(slide.type || "image")
            });
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return slides;
    }
    /**
     * Toggle visibility of thumbnail list
     * Tip: you can use `Fancybox.getInstance().plugins.Thumbs.toggle()` from anywhere in your code
     */

  }, {
    key: "toggle",
    value: function toggle() {
      if (this.state === "visible") {
        this.hide();
      } else if (this.state === "hidden") {
        this.show();
      } else {
        this.build();
      }
    }
    /**
     * Show thumbnail list
     */

  }, {
    key: "show",
    value: function show() {
      if (this.state === "hidden") {
        this.$container.style.display = "";
        this.Carousel.Panzoom.attachEvents();
        this.state = "visible";
      }
    }
    /**
     * Hide thumbnail list
     */

  }, {
    key: "hide",
    value: function hide() {
      if (this.state === "visible") {
        this.Carousel.Panzoom.detachEvents();
        this.$container.style.display = "none";
        this.state = "hidden";
      }
    }
    /**
     * Reset the state
     */

  }, {
    key: "cleanup",
    value: function cleanup() {
      if (this.Carousel) {
        this.Carousel.destroy();
        this.Carousel = null;
      }

      if (this.$container) {
        this.$container.remove();
        this.$container = null;
      }

      this.state = "init";
    }
  }, {
    key: "attach",
    value: function attach() {
      this.fancybox.on(this.events);
    }
  }, {
    key: "detach",
    value: function detach() {
      this.fancybox.off(this.events);
      this.cleanup();
    }
  }]);

  return Thumbs;
}(); // Expose defaults

Thumbs.defaults = defaults;